<div class="position-relative">
  <ng-content></ng-content>
  <div class="auto-complete" *ngIf="isShow()">
    <ng-content select="[options]" ></ng-content>
  </div>
</div>
